import { createContext, SetStateAction, Dispatch } from "react";

import { FormInstance } from "antd";

import { ActivitiesSectionForm, TableBeneficiaryItem } from "./StepFourFormProvider";
import { PaymentMethodForms } from "../../../../../../../../../shared/interfaces";

interface StepFourFormContextProps {
    /** Form Instance of vigency date section */
    validitySectionForm:                FormInstance<{ validityDate: any }>;

    /** Variable to save the selected payment method from the other step. */
    methodSelectedFromStepThree:        PaymentMethodForms | undefined;
    setMethodSelectedFromStepThree:     Dispatch<SetStateAction<PaymentMethodForms | undefined>>;

    /** Variable to save and show to the user the error on credit card form */
    errorCreditCardMessage:             string;
    setErrorCreditCardMessage:          Dispatch<SetStateAction<string>>;

    /** Form instance for activities section  */
    activitiesSectionForm:              FormInstance<ActivitiesSectionForm>;

    /** Variable to save activities form values */
    activitiesFormValues:               ActivitiesSectionForm | undefined;
    setActivitiesFormValues:            Dispatch<SetStateAction<ActivitiesSectionForm | undefined>>;

    /** Variable to save and manage beneficiaries table grid */
    beneficiaries:                       Array<TableBeneficiaryItem>
    setBeneficiaries:                    Dispatch<SetStateAction<Array<TableBeneficiaryItem>>>;

}

export const StepFourFormContext = createContext({} as StepFourFormContextProps);